<template>
  <div class="home">

  <Navbar/>

    <Hero
        :img="heroImg"
        :intro="'We are ' + ( this.$isUK ? 'the UK\'s' : 'Ireland\'s' ) + ' foremost'"
        title="Internet Infrastructure Specialists."
        :below1="'Led by ' + ( this.$isUK ? 'the ' : 'Ireland\'s' ) + ' most experienced network, system and VoIP engineers.'"
        below2="Delivering services to customers around the world."
    />


    <div class="container mx-auto m-0 pb-24 pt-6 px-3 sm:px-12 font-sans">

        <div v-if="notfound" class="bg-gray-700 rounded-full text-center py-4 lg:px-4 mb-8">
            <div class="p-2 items-center text-indigo-100 leading-none lg:rounded-full flex lg:inline-flex" role="alert">
                <span class="flex rounded-full bg-indigo-500 uppercase px-2 py-1 text-xs font-bold mr-3">404</span>
                <span class="font-semibold mr-2 text-left flex-auto">The page you requested was not found.</span>
            </div>
        </div>

        <div class="text-gray-700 text-base md:text-lg">
            <p class="mb-4">
                Island Bridge Networks was formed in 2014 by two <span v-if="!this.$isUK">of Ireland's most</span> experienced and industry
                leading internet infrastructure experts to provide a full-service network engineering, system administration and VoIP
                engineering consultancy.
            </p>
            <p class="mb-4">
                As a consultancy that caters primarily to internet service providers, we have a perspective and experience that beats
                any in-house network specialist. We can draw on our established track record of network designs, implementation and
                management. Our skilled engineers will leverage their many years of industry-specific expertise to your advantage.
            </p>
        </div>

        <div>
            <h3 class="text-gray-900 text-xl md:text-2xl font-semibold pt-4 mb-4">Service Industries / Customer Types</h3>

            <p class="text-gray-700 text-base md:text-lg mb-4">
                Our customers range from enterprises with mission-critical internet access requirements to large ISPs.
            </p>
        </div>

        <div class="flex flex-wrap -m-3">

            <Card v-for="(card, index) in cards" :key="index" v-bind:card="card" />

        </div>

        <p v-if="!this.$isUK" class="text-blue-700 font-semibold py-8 lg:px-32 text-center">
            Not sure what you need or if we're the right fit?
            <router-link class="border-b border-gray-500 border-solid hover:border-b-0" to="/coffee">Arrange a coffee with Barry or Nick here.</router-link>
            <br>
            We love to talk about things we know, and we love to hear about things we don’t.
        </p>


    </div>

    <Footer/>

  </div>
</template>

<script>
import Card     from '../components/Card.vue'
import Footer   from '../components/Footer.vue'
import Hero     from '../components/Hero.vue'
import Navbar   from '../components/Navbar.vue'

export default {
  name: 'home',
  beforeCreate: function() {
      document.body.className = 'bg-gray-200';
  },
  components: {
    Card,
    Footer, Navbar,
    Hero,
  },
  props: [ 'notfound' ],
  data () {
    return {
      heroImg: require('@/assets/sbb-night-east-2560x1600.jpg'),
      ibnLogo: require('@/assets/island-bridge-networks-500x500.png'),

      cards: [
          {
              title: 'B2B ISPs',
              content: 'ISPs specialising in business internet access and managed CPE resiliency. We work with these ISPs on bespoke customer designs also.'
          },
          {
              title: 'Residential ISPs',
              content: 'Fixed wireless, VDSL, FTTx and cable broadband providers to residential and small business customers.'
          },
          {
              title: 'VoIP ISPs',
              content: 'ISPs that specialise in VoIP services which have different characteristics and requirements than standard internet access.'
          },
          {
              title: 'Data Centres',
              content: 'Providing on site and campus internet access. Designing and managing in-house and campus-wide fibre assets with DWDM.'
          },
          {
              title: 'Internet Exchange Points (IXPs)',
              content: 'An IXP is the nexus of the internet for a large city or country. We have 35 years experience in this critical industry and consult with IXPs in Ireland, across Europe, Africa and the US.'
          },
          {
              title: 'Online Service Providers',
              content: 'We design, build and manage fault-tolerant always-available and DDoS resistant internet points of presence for providers of online services.'
          },
          {
              title: 'Government / State Agencies',
              content: 'Government and semi-state agencies with mission-critical internet access requirements (including hospitals and emergency services).'
          },
          {
              title: 'Utilty Companies',
              content: 'We help utilities such as electricity, water, gas, rail and roads leverage their infrastructure to provide fibre access services.'
          },
          {
              title: 'Enterprise / Commercial',
              content: 'Design, develop and manage resilient internet access for large enterprise / commercial businesses where loss of internet can cause significant cost in lost hours and productivity.'
          },

      ]
    }
  }
}
</script>
